export default __webpack_public_path__ + "static/media/A0000.aff02137.png";